import { Component, inject } from '@angular/core';
import { VendorShiftWorkingDayService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VendorShiftWorkingDayCreateDto,
  VendorShiftWorkingDayDto,
  VendorShiftWorkingDayExcelDownloadDto,
  VendorShiftWorkingDayUpdateDto,
} from '../proxy/controlling/dtos/vendor-shift-working-day';
import { VENDORSHIFTWORKINGDAY_CONFIG, VENDORSHIFTWORKINGDAY_FIELDS } from './vendor-shift-working-day.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vendor-shift-working-day',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VendorShiftWorkingDayService, ConfirmationService],
  templateUrl: './vendor-shift-working-day.html',
  styleUrl: './vendor-shift-working-day.scss',
})
export class VendorShiftWorkingDay extends BaseCrudComponent<
  VendorShiftWorkingDayDto,
  VendorShiftWorkingDayCreateDto,
  VendorShiftWorkingDayUpdateDto,
  VendorShiftWorkingDayExcelDownloadDto
> {
  service = inject(VendorShiftWorkingDayService);
  config = VENDORSHIFTWORKINGDAY_CONFIG;
  fields = VENDORSHIFTWORKINGDAY_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorShiftWorkingDayDto): VendorShiftWorkingDayUpdateDto {
    return {
      shiftWorkingDayId: data.shiftWorkingDayId,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VendorShiftWorkingDay';
  }
}
